import React, { useContext, useEffect, useMemo, useState } from "react";
import { useLanguage } from "../../../Providers/LanguageContext";
import { UserContext } from "../../../Providers/UserWrapper";
import HttpClient from "../../../utils/HttpClient";
import { data } from "jquery";
import { useNavigate } from "react-router-dom";

const Dashboardzerotwo = ({
  zeroDate,
  setZeroDate,
  dashboardZeroData,
  setDashbardZeroData,
  dashBoardZeroTaskData,
  setTime,
  time,
  userCode,
  selectedYear,
}) => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  // console.log('dashboardZeroData22', dashboardZeroData);
  const { isBusiness, setIsLoading, isInvestor } = useContext(UserContext);
  const [years, setYears] = useState([]);

  // console.log("dashBoardZeroTaskData", dashBoardZeroTaskData)
  const [customerType, setCustomerType] = useState("");
  // const [selectedYear, setSelectedYear] = useState("");
  const [custData, setCustData] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [isSearchList, setISSearchList] = useState(false);

  const [allClientNameData, setAllClientNameData] = useState([]);
  const [singleClient, setSingleClient] = useState({});
  const [clientInp, setClientInp] = useState("");
  const [clientInpShow, setClientInpShow] = useState("");
  const [clientNameSearch, setClientNameSearch] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const controlContainerStyle = {
    position: "absolute",
    top: "20px",
    right: "20px",
    zIndex: 10,
    backgroundColor: "white",
    padding: "8px 12px",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    border: "1px solid #e0e0e0",
    minWidth: "140px",
    textAlign: "center",
  };
  const currentYear = new Date().getFullYear();
  useEffect(() => {
    const yearsArray = [];
    for (let year = currentYear - 100; year <= currentYear + 10; year++) {
      yearsArray.push(year);
    }
    setYears(yearsArray);
  }, [currentYear]);

  const toggleCalendar = () => {
    setIsOpen(!isOpen);
  };
  // console.log("dashboardZeroData", dashboardZeroData)

  // change the type customer
  const handleChangeCustType = async (e) => {
    // setCustomerType(e.target.value)
    const cust = e.target.value;
    setCustomerType(cust);
    const data = {
      input_type: cust,
    };
    setIsLoading(true);
    const res = await HttpClient.requestData(
      "get-dashboard-zero-bu-input-data",
      "POST",
      data
    );
    // console.log("custres", res)
    if (res && res?.success) {
      switch (cust) {
        case "Customer":
          const filtData = removeDuplicateFunc(res?.data, "customerName");
          setCustData(filtData);
          break;
        case "Vendor":
          const filtData2 = removeDuplicateFunc(res?.data, "vendorName");
          setCustData(filtData2);
          break;
        default:
          setCustData([]);
      }
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  // remove duplicate from array of object
  const removeDuplicateFunc = (arr, key) => {
    const unique = arr.filter((obj, index) => {
      return index === arr.findIndex((o) => obj[key] === o[key]);
    });
    console.log("unique", unique);
    return unique;
  };

  // filter search data
  const filteredData = useMemo(() => {
    switch (customerType) {
      case "Customer":
        return custData?.filter((item) =>
          item?.customerName?.includes(searchName)
        );

      case "Vendor":
        return custData?.filter((item) =>
          item?.vendorName?.includes(searchName)
        );

      default:
        return [];
    }
  }, [customerType, custData, searchName]);

  // click on search list
  const handleSearchListClick = async (item) => {
    setSearchName(
      customerType === "Customer" ? item?.customerName : item?.vendorName
    );
    setISSearchList(true);

    if (time === "year") {
      const data = {
        dayType: time,
        year: selectedYear,
        input_type: customerType,
        input_name:
          customerType === "Customer" ? item?.customerName : item?.vendorName,
      };
      getDashZeroData(data);
    } else {
      const data = {
        input_type: customerType,
        input_name:
          customerType === "Customer" ? item?.customerName : item?.vendorName,
        dayType: time,
        startAR: zeroDate?.startDate,
        endAR: zeroDate?.endDate,
      };
      getDashZeroData(data);
    }

    // return
    // getDashZeroData(data);
  };

  useEffect(() => {
    // getDashZeroData(selectedYear);
    getDashZeroData({
      dayType: time,
      year: selectedYear,
      input_type: customerType,
      input_name: searchName,
    });
  }, [selectedYear, time]);

  // dash zero data get
  const getDashZeroData = async (data) => {
    // let payload;
    setIsLoading(true);
    // if (time === "year") {
    //   payload = {
    //     dayType: "year",
    //     year: data,
    //     // year: selectedYear,
    //     input_type: customerType,
    //     input_name: searchName,
    //   };
    // } else {
    //   payload = { ...data };
    // }
    // const res = await HttpClient.requestData("dashboard-zero-bu", "POST", data);
    const res = await HttpClient.requestData("dashboard-zero-bu", "POST", data);
    console.log("ress", res);
    if (res && (res?.success || res?.status)) {
      setIsLoading(false);
      setDashbardZeroData(res?.data);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (zeroDate?.startDate && zeroDate?.endDate) {
      // console.log("zerotrue", zeroDate?.startDate !== "" && zeroDate?.endDate !== "")

      const data = {
        input_type: customerType,
        input_name: searchName,
        dayType: time,
        startAR: zeroDate?.startDate,
        endAR: zeroDate?.endDate,
      };
      getDashZeroData(data);
    }
  }, [zeroDate]);

  // clear filter
  const handleClearFilter = () => {
    setCustomerType("");
    setCustData([]);
    setSearchName("");
    setISSearchList(false);
    setZeroDate({
      endDate: "",
      startDate: "",
    });
    setTime("day");

    const data = {
      input_type: "",
      input_name: "",
      dayType: time,
      startAR: "",
      endAR: "",
    };
    getDashZeroData(data);
  };

  useEffect(() => {
    getClintName();
  }, [userCode]);

  const getClintName = async () => {
    const res = await HttpClient.requestData(
      "investor/get-all-investor-linked-account-list",
      "GET"
    );
    // console.log("ressddcx", res)
    if (res && res?.status) {
      setAllClientNameData(res?.data);
      if (userCode) {
        const fndData = res?.data?.find(
          (ele) => ele?.accountRegCode === userCode
        );
        setSingleClient(fndData);
        setClientInp(fndData?.client_name);
      }
    }
  };

  const handleClientInvestorClick = (item) => {
    setSingleClient(item);
    setClientInp(item?.client_name);
    setClientInpShow("");
    navigate("/dashboard-manager", {
      state: {
        userRegCodr: item?.accountRegCode,
        slideNo: 0,
      },
    });
  };

  const timePeriod = ["day", "month", "week"];
  const handleYearClick = (year) => {
    // onYearChange(year.toString());
    // setSelectedYear(year);
    setIsOpen(false);
    getDashZeroData(year);
  };
  return (
    <div>
      <div id="config-form">
        <div className="container">
          {/* filter */}
          <div className="">
            <form>
              <div className="form-group">
                <div
                  className="dashboard-form-layout"
                  style={{ alignItems: "center" }}
                >
                  {isInvestor ? (
                    <div
                    // className="col-xl-2 col-lg-2 col-md-6 col-sm-12 col-sx-12 pt-4"
                    >
                      <div className="drpbox">
                        <input
                          type="search"
                          placeholder="Type-To-Search"
                          value={clientInp}
                          onChange={(e) => {
                            setClientInp(e.target.value);
                            setClientInpShow(e.target.value);
                            const fltData = allClientNameData?.filter((ele) => {
                              return ele?.client_name
                                ?.toLowerCase()
                                .includes(e.target.value?.toLowerCase());
                            });
                            setClientNameSearch(fltData);
                          }}
                        />
                      </div>

                      {clientInpShow !== "" && (
                        <div className="dashboard-zero-search">
                          {clientNameSearch?.length !== 0 ? (
                            clientNameSearch?.map((item, i) => (
                              <p
                                style={{
                                  color: "#fff",
                                }}
                                key={i}
                                onClick={() => handleClientInvestorClick(item)}
                              >
                                {item?.client_name}
                              </p>
                            ))
                          ) : (
                            <div
                              style={{
                                color: "#fff",
                              }}
                            >
                              No Data Found...
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      <div
                        style={{
                          border: "1px solid black",
                          marginBottom: "20px",
                          borderRadius: "5px",
                        }}
                        // className="col-xl-2 col-lg-2 col-md-6 col-sm-12 col-sx-12 pt-4"
                      >
                        <div className="">
                          <select
                            className="drpdwnlst"
                            value={customerType}
                            onChange={(e) => handleChangeCustType(e)}
                          >
                            <option value="">Select</option>
                            <option value="Customer">
                              {language.customers}
                            </option>
                            <option value="Vendor">
                              {language.Vendedores}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div
                        className=""
                        // className="col-xl-2 col-lg-2 col-md-6 col-sm-12 col-sx-12 pt-4"
                      >
                        <div className="drpbox">
                          <input
                            type="search"
                            placeholder="Type-To-Search"
                            value={searchName}
                            onChange={(e) => {
                              setISSearchList(false);
                              setSearchName(e.target.value);
                            }}
                          />
                        </div>

                        {searchName !== "" &&
                          customerType !== "" &&
                          !isSearchList && (
                            <div className="dashboard-zero-search">
                              {filteredData?.length !== 0 ? (
                                filteredData?.map((item, i) => (
                                  <p
                                    style={{
                                      color: "black",
                                    }}
                                    key={i}
                                    onClick={() => handleSearchListClick(item)}
                                  >
                                    {customerType === "Customer"
                                      ? item?.customerName
                                      : item?.vendorName}
                                  </p>
                                ))
                              ) : (
                                <div
                                  style={{
                                    color: "#fff",
                                  }}
                                >
                                  No Data Found...
                                </div>
                              )}
                            </div>
                          )}
                      </div>
                    </>
                  )}

                  <div className="bottom-form-wrp">
                    {timePeriod?.includes(time) && (
                      <div
                        className="bottom-field-wrp"
                        // className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-sx-12"
                      >
                        <label
                          className="mb-2"
                          style={{ fontSize: "1.2rem", color: "black" }}
                        >
                          {language.start_date}
                        </label>
                        <input
                          type="date"
                          className="form-control mb-3"
                          id=""
                          aria-describedby=""
                          value={zeroDate.startDate}
                          onChange={(e) => {
                            setZeroDate((prev) => ({
                              ...prev,
                              startDate: e.target.value,
                            }));
                            // setTime("");
                          }}
                        />
                      </div>
                    )}
                    {timePeriod?.includes(time) && (
                      <div
                        className="bottom-field-wrp"
                        // className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-sx-12"
                      >
                        <label className="mb-2" style={{ fontSize: "1.2rem" }}>
                          {language.final_date}
                        </label>
                        <input
                          type="date"
                          className="form-control mb-3"
                          id=""
                          aria-describedby=""
                          value={zeroDate.endDate}
                          onChange={(e) => {
                            setZeroDate((prev) => ({
                              ...prev,
                              endDate: e.target.value,
                            }));
                            // setTime("");
                          }}
                        />
                      </div>
                    )}
                    {/* {time === "year" && (
                      <div
                        style={{
                          ...controlContainerStyle,
                          minWidth: "100px",
                          cursor: "pointer",
                          position: "relative",
                          top: "-10px",
                          right: "-330px",
                          width: "30%",
                          marginTop: "50px",
                        }}
                      >
                        <div
                          onClick={toggleCalendar}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "4px 8px",
                          }}
                        >
                          <span
                            style={{ color: selectedYear ? "#102a3d" : "#999" }}
                          >
                            {selectedYear || "Select Year"}
                          </span>
                          <span style={{ fontSize: "12px", color: "#102a3d" }}>
                            ▼
                          </span>
                        </div>

                        {isOpen && (
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              right: 0,
                              backgroundColor: "white",
                              border: "1px solid #e0e0e0",
                              borderRadius: "8px",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                              maxHeight: "200px",
                              overflowY: "auto",
                              zIndex: 100,
                              marginTop: "4px",
                            }}
                          >
                            <div
                              style={{
                                padding: "8px",
                                backgroundColor: "#f8f9fa",
                                borderBottom: "1px solid #e0e0e0",
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                              }}
                            >
                              <input
                                type="text"
                                placeholder="Search year..."
                                style={{
                                  width: "100%",
                                  padding: "4px 8px",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                  fontSize: "12px",
                                }}
                                onChange={(e) => {
                                  const searchTerm = e.target.value;
                                  const filteredYears = years.filter((year) =>
                                    year.toString().includes(searchTerm)
                                  );
                                  setYears(filteredYears);
                                }}
                              />
                            </div>

                            <div
                              style={{
                                maxHeight: "150px",
                                overflowY: "auto",
                              }}
                            >
                              {years?.map((year) => (
                                <div
                                  key={year}
                                  onClick={() => handleYearClick(year)}
                                  // onClick={() => setSelectedYear(year)}
                                  style={{
                                    padding: "8px 12px",
                                    cursor: "pointer",
                                    borderBottom: "1px solid #f0f0f0",
                                    backgroundColor:
                                      selectedYear === year.toString()
                                        ? "#e3f2fd"
                                        : "white",
                                    color:
                                      selectedYear === year.toString()
                                        ? "#1976d2"
                                        : "#102a3d",
                                    fontSize: "14px",
                                    fontWeight:
                                      selectedYear === year.toString()
                                        ? "600"
                                        : "400",
                                    "&:hover": {
                                      backgroundColor: "#f5f5f5",
                                    },
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      "#f5f5f5")
                                  }
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                      selectedYear === year.toString()
                                        ? "#e3f2fd"
                                        : "white";
                                  }}
                                >
                                  {year}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    )} */}
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12 col-sx-12">
                    <button
                      style={{
                        color: "#fff",
                      }}
                      type="button"
                      className="fltrsall"
                      onClick={handleClearFilter}
                    >
                      Clear All Filters
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <section className="fisibility">
            <div className="">
              <div className="total">
                <div className="chart-one-grid-layout" style={{}}>
                  {/* <div className="revenue-box"
                  
                  style={{
                     
                    }}>
                    <div className="revenue-inner-box" >
                      <h4>
                        {isBusiness
                          ? language.revenue_total
                          : language.income_total}
                      </h4>
                      <span>
                        ${" "}
                        {
                          
                          dashboardZeroData.RevenueTotal
                        
                        }
                      </span>
                    </div>
                  </div> */}

                  {/* expese total */}
                  {/* <div className="revenue-box"
                 
                   style={{
                      
                    }}>
                    <div className="revenue-inner-box"
                    
                    >
                      <h4 className="">{language.expense_total}</h4>
                      <span className="">$ {dashboardZeroData.ExpenseTotal}</span>
                    </div>
                  </div> */}

                  {/* profit total */}
                  {/* <div className="revenue-box"
                 
                  style={{
                     
                    }}>
                    <div className="revenue-inner-box"
                   
                    >
                      <h4>{isBusiness ? language.profit_total : language.margin_total}</h4>
                      <span>$ {
                       
                        dashboardZeroData.ProfitTotal
                     
                      }
                      </span>
                    </div>
                  </div> */}

                  {/* AR TOTAL */}
                  {/* <div className="revenue-box"
                  
                   style={{
  
                    }}>
                    <div className="revenue-inner-box"
                    
                    >
                      <h4 className="" >
                        {isBusiness ? "AR TOTAL" : language.income_budget}
                      </h4>
                      <span>
                        ${" "}
                        {
                          
                          dashboardZeroData.ARTotal
                          
                        }
                      </span>
                    </div>
                  </div> */}

                  {/* CURRENT AR */}
                  {/* <div className="revenue-box"
                  
                  style={{
                      
                    }}>
                    <div className="revenue-inner-box"
                   
                    >
                      <h4>
                        {isBusiness ? "CURRENT AR" : language.expense_budget2}
                      </h4>
                      <span>
                        ${" "}
                        {
                          dashboardZeroData.CurrentAR
                        }
                      </span>
                    </div>
                  </div> */}

                  {/* PAST DUE AR   */}
                  {/* <div className="revenue-box"
                  
                  style={{
                      
                    }}>
                    <div className="revenue-inner-box"
                    
                    >
                      <h4 className="">
                        {isBusiness ? "PAST DUE AR" : language.margin_total}
                      </h4>
                      <span className="">
                        ${" "}
                        {
                          dashboardZeroData.PastDueAR
                        }
                      </span>
                    </div>
                  </div> */}

                  {/* EVENTS */}
                  {/* <div className="revenue-box"
                  
                  style={{
                  
                    }}>
                    <div className="revenue-inner-box"
                   
                    >
                      <h4>{language?.num_of_event}</h4>
                      <span>
                        {dashBoardZeroTaskData?.eventCount}
                      </span>
                    </div>
                  </div> */}

                  {/* TASKS */}
                  {/* <div className="revenue-box"
                  
                  style={{
                     
                    }}>
                    <div className="revenue-inner-box"
        
                    >
                      <h4 className="">{language.num_of_task}</h4>
                      <span className="">
                        {dashBoardZeroTaskData?.taskCount}
                      </span>
                    </div>
                  </div> */}

                  {/* PROJECTS */}
                  {/* <div className="revenue-box"
                 
                  style={{
                     
                    }}>
                    <div className="revenue-inner-box"
                    
                    >
                      <h4 >{language.num_of_project}</h4>
                      <span>
                        {dashBoardZeroTaskData?.projectCount}
                      </span>
                    </div>
                  </div> */}

                  {/* TOTAL #  ACTIVITIES */}
                  {/* <div className="revenue-box"
                 
                   style={{
                     
                    }}>
                    <div className="revenue-inner-box"
                    
                    >
                      <h4 className="">{language.total_num_activity}</h4>
                      <span className="">
                        {dashBoardZeroTaskData?.totalActivities}
                      </span>
                    </div>
                  </div> */}

                  {/* TOTAL # ACTIVITY HOURS */}
                  {/* <div className="revenue-box"
                  
                    style={{
                      
                    }}>
                    <div className="revenue-inner-box"
                    
                    >
                      <h4>{language.total_activity_hour}</h4>
                      <span>
                        {dashBoardZeroTaskData?.totalActivityHours && Number(dashBoardZeroTaskData?.totalActivityHours)?.toFixed(2)}
                       
                      </span>
                    </div>
                  </div> */}

                  {/* # UNASSIGNED ACTIVITIES */}
                  {/* <div className="revenue-box"
                  
                   style={{
                      
                    }}>
                    <div className="revenue-inner-box"
                    
                    >
                      <h4 className="">{language.unassigned_activity}</h4>
                      <span className="">
                        {dashBoardZeroTaskData?.unAssignDataCount}
                      </span>
                    </div>
                  </div> */}

                  {/* TOTAL #  CUSTOMERS */}
                  {/* <div className="revenue-box"
                 
                  style={{
                      
                    }}>
                    <div className="revenue-inner-box"
                 
                    >
                      <h4>{isBusiness ? language.total_customer : language.total_num_income_source}</h4>
                      <span>
                        {dashBoardZeroTaskData?.customerDataCount}
                       
                      </span>
                    </div>
                  </div> */}

                  {/* TOTAL #  VENDORS */}
                  {/* <div className="revenue-box"
                 
                   style={{
                      
                    }}>
                    <div className="revenue-inner-box"
              
                    >
                      <h4 className="">{language.total_vendors}</h4>
                      <span className="">
                        {dashBoardZeroTaskData?.vendorDataCount}
                      </span>
                    </div>
                  </div> */}

                  {/* TOTAL #  USERS */}
                  {/* <div className="revenue-box"
                 
                  style={{
                      
                    }}>
                    <div className="revenue-inner-box"
                    
                    >
                      <h4>{language.total_user}</h4>
                      <span>
                        {dashBoardZeroTaskData?.userCount}
                      </span>
                    </div>
                  </div> */}

                  {/*RECOMMENDATIONS */}
                  {/* <div className="revenue-box"
                 
                  style={{
                      
                    }}>
                    <div className="revenue-inner-box"
                  
                    >
                      <h4 className="">RECOMMENDATIONS</h4>
                      <span className="">
                         {dashBoardZeroTaskData?.userCount} 
                        ---
                      </span>
                    </div>
                  </div> */}

                  {/* # PROFITABLE EVENTS */}
                  {/* <div className="revenue-box"
                  
                   style={{
                      
                    }}>
                    <div className="revenue-inner-box"
                   
                    >
                      <h4># PROFITABLE EVENTS</h4>
                      <span>
                         {dashBoardZeroTaskData?.userCount} 
                        ---
                      </span>
                    </div>
                  </div> */}

                  {/* # PROFITABLE TASKS*/}
                  {/* <div className="revenue-box"
                  
                  style={{
                   
                    }}>
                    <div className="revenue-inner-box"
                    
                    >
                      <h4 className=""># PROFITABLE TASKS</h4>
                      <span className="">
                         {dashBoardZeroTaskData?.userCount} 
                        ---
                      </span>
                    </div>
                  </div> */}
                </div>
              </div>
              <div class="dashboard-wrapper">
                <div class="row-new-st row-1">
                  <div class="box">
                    {isBusiness
                      ? language.revenue_total
                      : language.income_total}

                    <span>$ {dashboardZeroData.RevenueTotal}</span>
                  </div>
                  <div class="box">
                    {language.expense_total}
                    <span>$ {dashboardZeroData.ExpenseTotal}</span>
                  </div>
                  <div class="box">
                    {isBusiness ? language.profit_total : language.margin_total}
                    <span>$ {dashboardZeroData.ProfitTotal}</span>
                  </div>
                  <div class="box">
                    {isBusiness ? "AR TOTAL" : language.income_budget}
                    <span> $ {dashboardZeroData.ARTotal}</span>
                  </div>
                  <div class="box">
                    {isBusiness ? "CURRENT AR" : language.expense_budget2}
                    <span> $ {dashboardZeroData.CurrentAR}</span>
                  </div>
                  <div class="box">
                    {isBusiness ? "PAST DUE AR" : language.margin_total}
                    <span>$ {dashboardZeroData.PastDueAR}</span>
                  </div>
                  <div class="box">
                    {language?.num_of_event}
                    <span>{dashBoardZeroTaskData?.eventCount}</span>
                  </div>
                </div>
                <div class="dotted-frame-2"></div>

                {/* MIDDLE ROW  */}
                <div class="row-new-st row-2">
                  <div class="box">
                    {language.num_of_task}
                    <span> {dashBoardZeroTaskData?.taskCount}</span>
                  </div>
                  <div class="box">
                    {language.num_of_project}
                    <span> {dashBoardZeroTaskData?.projectCount}</span>
                  </div>
                  <div class="box">
                    {language.total_num_activity}
                    <span> {dashBoardZeroTaskData?.totalActivities}</span>
                  </div>
                  <div class="box">
                    {language.total_activity_hour}
                    <span>
                      {" "}
                      {dashBoardZeroTaskData?.totalActivityHours &&
                        Number(
                          dashBoardZeroTaskData?.totalActivityHours
                        )?.toFixed(2)}
                      {/* --- */}
                    </span>
                  </div>
                  <div class="box">
                    {language.unassigned_activity}
                    <span>{dashBoardZeroTaskData?.unAssignDataCount}</span>
                  </div>
                  <div class="box">
                    {isBusiness
                      ? language.total_customer
                      : language.total_num_income_source}
                    <span>{dashBoardZeroTaskData?.customerDataCount}</span>
                  </div>
                </div>

                <div class="row-new-st row-3">
                  <div class="box">
                    {language.total_vendors}
                    <span> {dashBoardZeroTaskData?.vendorDataCount}</span>
                  </div>
                  <div class="box">
                    {language.total_user}
                    <span>{dashBoardZeroTaskData?.userCount}</span>
                  </div>
                  <div class="box">
                    RECOMMENDATIONS{" "}
                    <span>
                      {/* {dashBoardZeroTaskData?.userCount}  */}
                      ---
                    </span>
                  </div>
                  <div class="box">
                    # PROFITABLE EVENTS
                    <span>
                      {/* {dashBoardZeroTaskData?.userCount} */}
                      ---
                    </span>
                  </div>
                  <div class="box">
                    # PROFITABLE TASKS
                    <span>
                      {/* {dashBoardZeroTaskData?.userCount} */}
                      ---
                    </span>
                  </div>
                </div>
                {/* L-SHAPE DOTTED FRAME  */}
                <div class="dotted-frame"></div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Dashboardzerotwo;
